// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"VideoCardModule_cardContainer__wB2BU","cardHeader":"VideoCardModule_cardHeader__2_QIL","cardBody":"VideoCardModule_cardBody__1UHcG"};